import AuthenticatedImage from "./AuthenticatedImage"; // Import the AuthenticatedImage component
import EmployeeInfoButtons from "./EmployeeInfoButtons";

const EmployeeInfoTopSection = ({ employeeData }) => {
  return (
    <div className="bg-third rounded-3xl p-6 flex lg:flex-row flex-col gap-5 items-start justify-between">
      <div className="flex md:flex-row flex-col items-start gap-3 font-semibold">
        {/* Replace img with AuthenticatedImage */}
        <AuthenticatedImage
          src={employeeData?.photo_url}
          alt={`${employeeData?.name}'s profile`}
          className="w-40 h-40 rounded-full object-cover"
          fallback={
            <div className="w-40 h-40 rounded-full bg-gray-200 flex items-center justify-center">
              <span className="text-gray-500 text-2xl font-bold">
                {employeeData?.name?.charAt(0)?.toUpperCase() || "E"}
              </span>
            </div>
          }
        />
        <div className="flex flex-col gap-5">
          <h3 className="text-xl">{employeeData?.name}</h3>
          <div className="flex flex-col gap-6">
            <p className="flex items-center gap-2">
              <span className="text-sixth">Role:</span>
              {employeeData?.role?.name}
            </p>
            <p className="flex items-center gap-2 text-primary">
              <span className="text-sixth">Account Status:</span>
              {employeeData?.active ? "Active" : "Inactive"}
            </p>
            <p className="flex items-center gap-2">
              <span className="text-sixth">Phone Number:</span>
              {employeeData?.phone_number}
            </p>
            <p className="flex items-center gap-2">
              <span className="text-sixth">Join Date:</span>
              {employeeData?.created_at}
            </p>
            <p className="flex items-center gap-2">
              <span className="text-sixth">Last Login:</span>
              {employeeData?.last_login_at}
              AM
            </p>
          </div>
        </div>
      </div>
      <EmployeeInfoButtons />
    </div>
  );
};

export default EmployeeInfoTopSection;
